function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M69.3445 36.1644C69.3445 33.2556 69.1085 31.1329 68.5977 28.9316H35.3816V42.0607H54.8787C54.4857 45.3234 52.3631 50.2371 47.6459 53.5388L47.5798 53.9784L58.0821 62.1144L58.8097 62.187C65.4921 56.0154 69.3445 46.935 69.3445 36.1644",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.3816 70.756C44.9335 70.756 52.9525 67.6112 58.8097 62.1867L47.6459 53.5385C44.6585 55.6219 40.6489 57.0763 35.3816 57.0763C26.0261 57.0763 18.0858 50.905 15.2553 42.375L14.8404 42.4102L3.91991 50.8617L3.7771 51.2587C9.59476 62.8154 21.5447 70.756 35.3816 70.756Z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.2554 42.3753C14.5085 40.174 14.0763 37.8153 14.0763 35.3782C14.0763 32.9409 14.5085 30.5825 15.2161 28.3812L15.1963 27.9124L4.13901 19.3252L3.77723 19.4973C1.37949 24.293 0.00366211 29.6785 0.00366211 35.3782C0.00366211 41.078 1.37949 46.4632 3.77723 51.2589L15.2554 42.3753",
  fill: "#FBBC05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.3816 13.6794C42.0247 13.6794 46.5058 16.549 49.061 18.947L59.0455 9.19829C52.9134 3.49851 44.9335 0 35.3816 0C21.5447 0 9.59476 7.94035 3.7771 19.4971L15.216 28.381C18.0858 19.851 26.0261 13.6794 35.3816 13.6794",
  fill: "#EB4335"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 69.3812,
  height: 71,
  fill: "white"
})));

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 71,
    viewBox: "0 0 70 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.612a92ab.svg";
export { ForwardRef as ReactComponent };